import React from 'react';
import {Box, Divider} from "@mui/material";
import YeloIcon from "app/components/Icons/YeloIcon";
import {header, headerContainer} from "app/components/Header/Header.sx";

const Header = () => {
    return (
        <Box sx={header}>
            <Box sx={headerContainer}>
                <YeloIcon/>
            </Box>
            <Divider sx={{position: 'relative',width: '100%'}}/>
        </Box>
    );
};

export default Header;